module.exports = __webpack_public_path__ + "media/images/emblems/Lumino-coat_of_arms-9384d7e82edc4dcf7e00d9087c7c0c5d.svg";